module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.144 11.144\"><path id=\"パス_7\" data-name=\"パス 7\" d=\"M2808.082,4360.694a5.551,5.551,0,0,0-3.839,1.543l-.8-.8a.54.54,0,0,0-.921.382v3.012a.54.54,0,0,0,.539.539h3.012a.54.54,0,0,0,.382-.921l-.938-.938a3.774,3.774,0,1,1,.092,5.6.269.269,0,0,0-.368.012l-.891.891a.27.27,0,0,0,.011.392,5.572,5.572,0,1,0,3.723-9.708Z\" transform=\"translate(-2802.52 -4360.694)\" fill=\"#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/undo.svg
// module id = OFwj
// module chunks = 1